<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
      <div class="row mb-2">
          <div class="col-sm-6">
              <h1>{{phase?.level?.course?.from?.name}}-{{phase?.level?.course?.to?.name}} Kursu {{phase?.level?.name}}. seviye {{phase?.name}}. aşama</h1>
          </div>
          <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item"><a href="/admin">Ana Sayfa</a></li>
                  <li class="breadcrumb-item"><a href="/coursedetail/{{phase?.level?.courseId}}">{{phase?.level?.course?.from?.name}}-{{phase?.level?.course?.to?.name}}</a></li>
                  <li class="breadcrumb-item"><a href="/leveldetail/{{phase?.levelId}}">{{phase?.level?.name}}</a></li>
                  <li class="breadcrumb-item active">{{phase?.name}}</li>
              </ol>
          </div>
      </div>
  </div>
  <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
  <!-- Default box -->
  <div class="container-fluid">
      <div class="card">
          <div class="card-header">
              <h3 class="card-title">Kelimeler


                <button class="btn btn-primary pull-right" (click)="openSaveModal()">+Yeni Ekle</button>
                <a class="btn btn-danger pull-right" href="https://cdn.linguwa.com/sablon.xlsx" target="_blank">Excel Şablon</a>
                <input type="file" class="file-input" (change)="upload($event)" #fileUpload>

                <button   class="btn btn-primary pull-right"
                (click)="fileUpload.click()">
                Excel Yükle
              </button>


              </h3>


          </div>
          <div class="card-body">


            <table class="table table-bordered">
              <thead>
              <tr>
                <th>Sıra</th>
                <th>İcon</th>
                <th>Duvar Kağıdı</th>
                <th>Kelime</th>
                <th>Anlamı</th>



                <th>İşlemler</th>
              </tr>
              </thead>
              <tbody>
                <tr *ngFor="let lang of phase?.keywords" >
                  <td>{{lang.order}}</td>
                  <td ><img src="{{lang.icon}}" height="30"></td>
                  <td ><img src="{{lang.wallpaper}}" height="30"></td>
                  <td>{{lang.word}}</td>

                  <td>{{lang.translate}}</td>



                  <td>
                     <button class="btn btn-icon btn-pure success" (click)="detail(lang.id)"><i class="fa fa-info"></i> </button>
                     |
                     <button class="btn btn-icon btn-pure info" (click)="edit(lang)" title="düzenle"><i class="fa fa-edit"></i> </button>
                     |
                     <button class="btn btn-icon btn-pure danger" (click)="delete(lang.id)"><i class="fa fa-trash"></i></button></td>

                </tr>
              </tbody>

            </table>




          </div>
          <!-- /.card-body -->
          <div class="card-footer"></div>
          <!-- /.card-footer-->
      </div>
  </div>
  <!-- /.card -->
</section>
<!-- /.content -->
